import { useEffect } from 'react';

const PrivacyPolicy = () => {
  useEffect(() => {
    document.title = 'HexaCRM - Privacy Policy';
  }, []);

  return (
    <div>
      {/* Page Header */}
      <section className="page-header">
        <div className="container position-relative z-2">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8">
              <h1 className="display-3 text-white fw-bold">Privacy Policy</h1>
              <p className="lead hero-text">
                Your privacy is important to us
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-lg">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="card shadow">
                <div className="card-body p-5">
                  <p className="text-muted mb-2"><strong>Effective On:</strong> February 2026</p>

                  <p className="text-muted mb-4">
                    Hexa CRM ("we", "our", "us") values your privacy. This Privacy Policy explains what information we collect, how we use it, and how we protect it when you use our CRM application.
                  </p>
                  <p className="text-muted mb-4">
                    Hexa CRM is designed to help businesses manage leads, quotes, POS, stock, calls, WhatsApp messaging, and multi-user access in a simple and secure way.
                  </p>

                  <h4 className="fw-bold">1. Information We Collect</h4>
                  <p className="text-muted mb-3">We collect only the information required to provide our CRM services.</p>

                  <p className="text-muted mb-2"><strong>a. Information You Provide</strong></p>
                  <p className="text-muted mb-2">When you use Hexa CRM, you may provide:</p>
                  <ul className="text-muted mb-3">
                    <li>Name, email address, phone number</li>
                    <li>Company details</li>
                    <li>Login credentials</li>
                    <li>Lead, customer, quote, POS, and stock information</li>
                    <li>User and role details for multi-user management</li>
                  </ul>
                  <p className="text-muted mb-4">We do not collect or store credit card or payment details.</p>

                  <p className="text-muted mb-2"><strong>b. Information Collected Automatically</strong></p>
                  <p className="text-muted mb-2">When you use the app, we may automatically collect:</p>
                  <ul className="text-muted mb-3">
                    <li>Device information</li>
                    <li>Log data (login time, feature usage)</li>
                    <li>App performance and error logs</li>
                  </ul>
                  <p className="text-muted mb-4">This information is used only to improve app performance and reliability.</p>

                  <h4 className="fw-bold">2. Calls and WhatsApp Usage</h4>
                  <p className="text-muted mb-2">Hexa CRM supports:</p>
                  <ul className="text-muted mb-3">
                    <li>Outgoing and incoming call tracking</li>
                    <li>WhatsApp messaging for business communication</li>
                  </ul>
                  <p className="text-muted mb-1">We do not record call audio unless explicitly enabled by the user/device.</p>
                  <p className="text-muted mb-1">We do not send SMS messages to customers.</p>
                  <p className="text-muted mb-4">WhatsApp messaging is used only as initiated by the user.</p>

                  <h4 className="fw-bold">3. How We Use Your Information</h4>
                  <p className="text-muted mb-2">We use your information to:</p>
                  <ul className="text-muted mb-3">
                    <li>Provide and operate Hexa CRM features</li>
                    <li>Manage leads, quotes, POS, and stock</li>
                    <li>Enable multi-user access and role management</li>
                    <li>Support customer service and issue resolution</li>
                    <li>Improve application features and security</li>
                  </ul>
                  <p className="text-muted mb-4">We do not sell, rent, or trade your data.</p>

                  <h4 className="fw-bold">4. Data Sharing</h4>
                  <p className="text-muted mb-2">We do not share your personal or business data with third parties except:</p>
                  <ul className="text-muted mb-4">
                    <li>When required by law</li>
                    <li>To protect against fraud or security issues</li>
                    <li>For essential technical services (such as hosting), under strict confidentiality</li>
                  </ul>

                  <h4 className="fw-bold">5. Data Security</h4>
                  <p className="text-muted mb-2">We take reasonable technical and organizational measures to protect your data from:</p>
                  <ul className="text-muted mb-3">
                    <li>Unauthorized access</li>
                    <li>Loss or misuse</li>
                    <li>Disclosure or alteration</li>
                  </ul>
                  <p className="text-muted mb-4">Access to data is limited to authorized personnel only.</p>

                  <h4 className="fw-bold">6. Data Retention</h4>
                  <p className="text-muted mb-2">We retain your data only as long as:</p>
                  <ul className="text-muted mb-3">
                    <li>Your account is active, or</li>
                    <li>Required for legitimate business or legal purposes</li>
                  </ul>
                  <p className="text-muted mb-4">You may request data deletion upon account closure.</p>

                  <h4 className="fw-bold">7. User Rights</h4>
                  <p className="text-muted mb-2">You have the right to:</p>
                  <ul className="text-muted mb-4">
                    <li>Access your data</li>
                    <li>Update or correct your data</li>
                    <li>Request deletion of your data</li>
                    <li>Control app permissions via your device settings</li>
                  </ul>

                  <h4 className="fw-bold">8. Children's Privacy</h4>
                  <p className="text-muted mb-1">Hexa CRM is not intended for users under the age of 16.</p>
                  <p className="text-muted mb-4">We do not knowingly collect data from minors.</p>

                  <h4 className="fw-bold">9. Changes to This Privacy Policy</h4>
                  <p className="text-muted mb-1">We may update this Privacy Policy from time to time.</p>
                  <p className="text-muted mb-4">Any major changes will be communicated within the app or via email.</p>

                  <h4 className="fw-bold">10. Contact Us</h4>
                  <p className="text-muted mb-2">If you have questions or concerns about this Privacy Policy, please contact us at:</p>
                  <p className="text-muted mb-1">Email: <a href="mailto:support@blazehexa.com" className="text-primary">support@blazehexa.com</a></p>
                  <p className="text-muted mb-0">Product: Hexa CRM</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
